import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorMessage = (err) => {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) return d[0]?.msg?.replace(/^Value error, /, "") || "Please check your details";
  return d || "Something went wrong. Please try again.";
};

export const api = axios.create({ baseURL: API });

export const LIVE_URL = "https://live.tradingnifty.in/";
export const WHATSAPP_URL = `https://wa.me/919733535551?text=${encodeURIComponent("Hi Nitesh, I have a question about Trading Nifty.")}`;

export const INTERESTS = [
  "AI strategy builder & backtesting",
  "Daily market calls & research",
  "Strategy marketplace (SEBI RA)",
  "Portfolio & advisory services",
  "Algo / API subscriptions",
];
